import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CasesService } from 'src/app/core/services/cases.service';

enum Texts {
  makeAnalysis = 'Realizar un análisis de los casos con potencialidad de reporte. (5.1)',
  bankSystemDB = 'Ingresar a la Base de datos del sistema bancario (5.2)',
  locateTheCustomer = 'Ubicar al cliente (5.3)',
  validateCustomerClassification = 'Validar la clasificacion del cliente (5.4)',
  customerActivity = 'Revisa datos complementarios y actividad del cliente (5.5)',
  otherAccounts = 'Verifica si el cliente, adicional a su cuenta principal, está autorizado al manejo y uso de otras cuentas. (5.6)',
  analyzeAccounts = 'Analiza las cuentas de origen de fondos y realiza una evaluación (5.7)',
}

@Component({
  selector: 'app-analyze-ras',
  templateUrl: './analyze-ras.component.html',
  styleUrls: ['./analyze-ras.component.scss'],
})
export class AnalyzeRasComponent implements OnInit {
  public Texts = Texts;

  @Input() data: { task: any };

  constructor(
    private readonly fb: FormBuilder,
    private caseService: CasesService
  ) {}

  form: FormGroup = this.fb.group({
    makeAnalysis: [false],
    bankSystemDB: [false],
    locateTheCustomer: [false],
    validateCustomerClassification: [false],
    customerActivity: [false],
    otherAccounts: [false],
    analyzeAccounts: [false],
    status: ['', [Validators.required]],
  });

  ngOnInit() {
    const { task } = this.data;

    const values = task.data;
    if (values) {
      this.form.setValue(values);
    }
    this.form.valueChanges.subscribe(x => {
      if(x.status != 'pending')
        this.caseService.update( this.data.task.case, {status: 'running'}).subscribe((res:any)=>{return res})
      if( x.status == 'pending')
        this.caseService.update( this.data.task.case, {status: 'pending'}).subscribe((res:any)=>{return res})
    })
  }
}
